import { useDashboardAuth } from '@quality24/react-auth';
import { AppAuthResponsePayload } from '../../@types/auth';

/**
 * Serves as a wrapper around useDashboardAuth hook for the inpatient-dashboard application.
 */
export const useAuth = () => {
  const auth = useDashboardAuth<AppAuthResponsePayload['userData']>();
  return auth;
};
